(function () {
  'use strict';

  // ---------- Helpers ----------
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
  const $1 = (root, sel) => root.querySelector(sel);

  // Basic debounce to avoid hammering during grid reflows
  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  // Extract product handle from the card's main link
  function getHandleFromItem(li) {
    const a = $1(li, 'a.snize-view-link');
    if (!a) return null;
    try {
      // Handles typical /collections/.../products/{handle}
      const parts = a.pathname.split('/products/');
      if (parts.length < 2) return null;
      let handle = parts[1].split('/')[0];
      handle = handle.split('?')[0].split('#')[0];
      return handle || null;
    } catch (e) { return null; }
  }

  // Build the URL to your JSON view (template product.perm2.liquid)
  function jsonUrlForHandle(handle) {
    return `/products/${encodeURIComponent(handle)}?view=perm2`;
  }

  // Insert “From €XX.XX / m²” under the app price
  function injectPerm2(li, moneyString) {
    // Avoid duplicates
    if (li.dataset.wotPerm2Injected === 'true') return;

    const priceWrap = $1(li, '.snize-price-list');
    if (!priceWrap) return;

    const line = document.createElement('span');
    line.className = 'wot-perm2';
    line.innerHTML =
      `<span class="wot-perm2-value">${moneyString}</span>` +
      ` <span class="wot-perm2-unit">/ m²</span>`;

    priceWrap.appendChild(line);
    li.dataset.wotPerm2Injected = 'true';
  }

  // Append " / {unitType}" to the two price spans (once)
  function appendUnitTypeToPrices(li, unitType) {
    if (!unitType || unitType === 'Unit') return;

    // Existing targets plus the new generic node
    const candidates = [
      $1(li, '.snize-price.snize-price-with-discount.money'),
      $1(li, '.snize-discounted-price.money'),
      $1(li, '.snize-price') // <-- new target
    ];

    const seen = new Set();

    const addSuffix = (el) => {
      if (!el) return;
      if (seen.has(el)) return; // avoid double-processing same node
      seen.add(el);

      if (el.dataset.wotUnitTypeAppended === 'true') return;

      const txt = el.textContent || '';
      if (txt.includes(`/${unitType}`) || txt.includes(`/ ${unitType}`)) {
        el.dataset.wotUnitTypeAppended = 'true';
        return;
      }

      const suffix = document.createElement('span');
      suffix.className = 'wot-price-unit';
      suffix.textContent = ` / ${unitType}`;
      el.appendChild(suffix);
      el.dataset.wotUnitTypeAppended = 'true';
    };

    candidates.forEach(addSuffix);
  }

  // ---------- Main processor ----------
  const responseCache = new Map(); // handle -> parsed JSON or null

  async function processGrid(root) {
    const items = $$(root, 'li.snize-product');
    if (!items.length) return;

    for (const li of items) {
      const handle = getHandleFromItem(li);
      if (!handle) continue;

      try {
        let data;
        if (responseCache.has(handle)) {
          data = responseCache.get(handle);
        } else {
          const res = await fetch(jsonUrlForHandle(handle), { credentials: 'same-origin' });
          if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
          data = await res.json();
          responseCache.set(handle, data);
        }

        const unitType = String((data && data.unit_type) || 'Unit');

        // price_sqm comes from the JSON view as a boolean; default to false if missing
        // Accepts true/false, "true"/"false", 1/0 just in case.
        const raw = data && data.price_sqm;
        const priceSqm =
          raw === true || raw === 'true' || raw === 1 || raw === '1'
            ? true
            : false;

        if (unitType !== 'Unit') {
          // Always append the unit suffix for non-Unit products
          appendUnitTypeToPrices(li, unitType);

          // Inject /m² ONLY when priceSqm == false
          if (priceSqm === false) {
            const money = data?.summary?.min_price_per_m2_money || null;

            let moneyString = money;
            if (!moneyString && typeof data?.summary?.min_price_per_m2_value === 'number') {
              moneyString = data.summary.min_price_per_m2_value.toFixed(2);
            }

            if (moneyString) {
              injectPerm2(li, moneyString);
            } else {
              li.dataset.wotPerm2Injected = 'true';
            }
          } else {
            // price_sqm is true → do not inject /m² line
            li.dataset.wotPerm2Injected = 'true';
          }
        } else {
          // Unit → do nothing
          li.dataset.wotPerm2Injected = 'true';
        }
      } catch (err) {
        // console.warn('perm2 fetch error for', handle, err);
        li.dataset.wotPerm2Injected = 'true';
      }
    }
  }

  // Kick once on load (handles initial render)
  function runOnce() {
    const grid = document.getElementById('snize-search-results-grid-mode') || document;
    processGrid(grid);
  }

  // Observe future DOM updates from the faceted app (AJAX renders)
  const observer = new MutationObserver(
    debounce(() => runOnce(), 120)
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Also run after window load just in case
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOnce, { once: true });
  } else {
    runOnce();
  }

  // Optional: re-run on Searchanise custom events if they exist
  window.addEventListener('snize:products_updated', runOnce);
  window.addEventListener('snize:results_rendered', runOnce);
})();


// (function () {
//   'use strict';

//   // ---------- Helpers ----------
//   const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
//   const $1 = (root, sel) => root.querySelector(sel);

//   // Basic debounce to avoid hammering during grid reflows
//   function debounce(fn, wait) {
//     let t;
//     return function () {
//       clearTimeout(t);
//       t = setTimeout(() => fn.apply(this, arguments), wait);
//     };
//   }

//   // Extract product handle from the card's main link
//   function getHandleFromItem(li) {
//     const a = $1(li, 'a.snize-view-link');
//     if (!a) return null;
//     try {
//       // Handles typical /collections/.../products/{handle}
//       const parts = a.pathname.split('/products/');
//       if (parts.length < 2) return null;
//       let handle = parts[1].split('/')[0];
//       handle = handle.split('?')[0].split('#')[0];
//       return handle || null;
//     } catch (e) { return null; }
//   }

//   // Build the URL to your JSON view (template product.perm2.liquid)
//   function jsonUrlForHandle(handle) {
//     return `/products/${encodeURIComponent(handle)}?view=perm2`;
//   }

//   // Insert “From €XX.XX / m²” under the app price
//   function injectPerm2(li, moneyString) {
//     // Avoid duplicates
//     if (li.dataset.wotPerm2Injected === 'true') return;

//     const priceWrap = $1(li, '.snize-price-list');
//     if (!priceWrap) return;

//     const line = document.createElement('span');
//     line.className = 'wot-perm2';
//     line.innerHTML =
//       `<span class="wot-perm2-value test">${moneyString}</span>` +
//       ` <span class="wot-perm2-unit">/ m²</span>`;

//     priceWrap.appendChild(line);
//     li.dataset.wotPerm2Injected = 'true';
//   }

//   // Append " / {unitType}" to the two price spans (once)
//   function appendUnitTypeToPrices(li, unitType) {
//     if (!unitType || unitType === 'Unit') return;

//     const basePrice = $1(li, '.snize-price.snize-price-with-discount.money');
//     const compareAt = $1(li, '.snize-discounted-price.money');

//     const addSuffix = (el) => {
//       if (!el) return;
//       if (el.dataset.wotUnitTypeAppended === 'true') return;

//       // Avoid double-append if text already contains the unitType
//       const txt = el.textContent || '';
//       if (txt.includes(`/${unitType}`) || txt.includes(`/ ${unitType}`)) {
//         el.dataset.wotUnitTypeAppended = 'true';
//         return;
//       }

//       const suffix = document.createElement('span');
//       suffix.className = 'wot-price-unit';
//       suffix.textContent = ` / ${unitType}`;
//       el.appendChild(suffix);
//       el.dataset.wotUnitTypeAppended = 'true';
//     };

//     addSuffix(basePrice);
//     addSuffix(compareAt);
//   }

//   // ---------- Main processor ----------
//   const responseCache = new Map(); // handle -> parsed JSON or null

//   async function processGrid(root) {
//     const items = $$(root, 'li.snize-product');
//     if (!items.length) return;

//     // Work through visible items
//     for (const li of items) {
//       // Note: we track these independently so unit suffix can be added
//       const handle = getHandleFromItem(li);
//       if (!handle) continue;

//       try {
//         let data;
//         if (responseCache.has(handle)) {
//           data = responseCache.get(handle);
//         } else {
//           const res = await fetch(jsonUrlForHandle(handle), { credentials: 'same-origin' });
//           if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
//           data = await res.json();
//           responseCache.set(handle, data);
//         }

//         const unitType = (data && data.unit_type) ? String(data.unit_type) : 'Unit';
//         const priceSqm = (data && data.price_sqm) ? String(data.price_sqm) : 'Unit';

//         // Append unit type to price spans ONLY when unitType !== "Unit"
//         if (unitType !== 'Unit') {
//           appendUnitTypeToPrices(li, unitType);

//           // Prefer formatted money string from your view
//           const money = data?.summary?.min_price_per_m2_money || null;

//           // Fallback: compute from numeric if needed
//           let moneyString = money;
//           if (!moneyString && typeof data?.summary?.min_price_per_m2_value === 'number') {
//             moneyString = data.summary.min_price_per_m2_value.toFixed(2);
//           }

//           if (moneyString) {
//             injectPerm2(li, moneyString);
//           } else {
//             li.dataset.wotPerm2Injected = 'true';
//           }
//         } else {
//           // unitType === "Unit": do not append, do not inject /m²
//           li.dataset.wotPerm2Injected = 'true';
//         }
//       } catch (err) {
//         // console.warn('perm2 fetch error for', handle, err);
//         li.dataset.wotPerm2Injected = 'true';
//       }
//     }
//   }

//   // Kick once on load (handles initial render)
//   function runOnce() {
//     const grid = document.getElementById('snize-search-results-grid-mode') || document;
//     processGrid(grid);
//   }

//   // Observe future DOM updates from the faceted app (AJAX renders)
//   const observer = new MutationObserver(
//     debounce(() => runOnce(), 120)
//   );

//   observer.observe(document.documentElement, {
//     childList: true,
//     subtree: true
//   });

//   // Also run after window load just in case
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', runOnce, { once: true });
//   } else {
//     runOnce();
//   }

//   // Optional: re-run on Searchanise custom events if they exist
//   window.addEventListener('snize:products_updated', runOnce);
//   window.addEventListener('snize:results_rendered', runOnce);
// })();
